// 기본 Moon 선택. 엔드포인트(VITE_MOON_ENDPOINT)가 설정돼 있으면 실제 프록시(httpMoon),
// 아니면 오프라인/프리뷰용 mockMoon. respond.ts가 이걸 기본값으로 쓴다.

import type { Moon } from "./moon";
import { mockMoon } from "./moon";
import { httpMoon } from "./httpMoon";

// Bwek의 기존 프록시를 절대 URL로 호출(Hyuh는 다른 도메인 → CORS, 프록시가 허용).
// 웹/네이티브 모두 절대 URL. 비워두면 mock으로 동작.
const ENDPOINT = (typeof import.meta !== "undefined" && import.meta.env?.VITE_MOON_ENDPOINT) || "";

export const defaultMoon: Moon = ENDPOINT ? httpMoon(ENDPOINT) : mockMoon;
export const usingRealMoon = Boolean(ENDPOINT);
